import FirebaseProvider from './firebase';

export default FirebaseProvider;
